<template>
  <NewBsBox
    :bs="{
      'cmp.table.sort': 'wrap',
    }"
    as="span"
  >
    <NewBsBox
      :bs="{
        'cmp.table.sort': 'arrowUp',
        'cmp.table.sort.arrowUp': ascActive ? 'active' : '',
      }"
      as="span"
      @click="$emit('clickAsc')"
    />
    <NewBsBox
      :bs="{
        'cmp.table.sort': 'arrowDown',
        'cmp.table.sort.arrowDown': descActive ? 'active' : '',
      }"
      as="span"
      @click="$emit('clickDesc')"
    />
  </NewBsBox>
</template>

<script>
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'

  export default {
    components: {
      NewBsBox,
    },
    props: {
      ascActive: {
        type: Boolean,
        default: false,
      },
      descActive: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['clickDesc', 'clickAsc'],
  }
</script>
